import { IFormViewForm } from 'components/FormView';

const PurchaseOrderLineDetailsForm: IFormViewForm = {
    id: 'PurchaseOrderLineDetailsForm',
    layout: {
        rows: 1,
        columns: 2
    },
    fields: [
        {
            id: 1,
            position: {
                row: 1,
                col: 1
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                label: '',
                fullWidth: true
            },
            children: [
                {
                    id: '0',
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Product',
                        name: 'ProductIdDisplay',
                        placeholder: '',
                        size: 'medium',
                        required: false,
                        readOnly: true,
                        disabled: true
                    }
                },
                {
                    id: '1',
                    type: 'TEXT_FIELD',
                    props: {
                        name: 'Description',
                        placeholder: '',
                        size: 'large',
                        required: false,
                        inputProps: {
                            maxLength: 40
                        }
                    }
                },
                {
                    id: '2',
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Ordered',
                        name: 'OrderedQuantity',
                        placeholder: '',
                        size: 'small',
                        decimalSeparator: true,
                        alignment: 'right',
                        decimalPlaces: 2
                    }
                },
                {
                    id: '3',
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'On order',
                        name: 'BackorderedQuantity',
                        placeholder: '',
                        size: 'small',
                        decimalSeparator: true,
                        alignment: 'right',
                        decimalPlaces: 2
                    }
                },
                {
                    id: '4',
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Buying unit',
                        name: 'BuyingUnit',
                        placeholder: '',
                        size: 'medium',
                        lookupName: 'UnitCode',
                    }
                },
                {
                    id: '5',
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Unit conversion factor',
                        name: 'UnitConversion',
                        placeholder: '',
                        size: 'small',
                        decimalSeparator: true,
                        alignment: 'right',
                        decimalPlaces: 4
                    }
                },
                {
                    id: '6',
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Supplier product',
                        name: 'SupplierProduct',
                        placeholder: '',
                        lookupName: 'SupplierProduct',
                        isSupplierScoped: true,
                        suppressValidation: true,
                        maxLength: 20
                    }
                },
                {
                    id: '7',
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Price',
                        name: 'Price',
                        placeholder: '',
                        size: 'medium',
                        decimalSeparator: true,
                        alignment: 'right',
                        decimalPlaces: 4
                    }
                },
                {
                    id: '8',
                    type: 'TEXT_FIELD',
                    visible: true,
                    props: {
                        label: 'Base price',
                        name: 'BasePrice',
                        size: 'medium',
                        type: 'number',
                        decimalSeparator: true,
                        alignment: 'right',
                        decimalPlaces: 4
                    }
                },
                {
                    id: '9',
                    type: 'EXTENDED_DISPLAY_FIELD',
                    props: {
                        label: 'Discount',
                        name: 'Discount',
                        placeholder: '',
                        size: 'small',
                        type: 'number',
                        decimalSeparator: true,
                        adornment: '%',
                    }
                },
                {
                    id: '10',
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    props: {
                        label: 'Special price',
                        name: 'SpecialPrice'
                    }
                },
                {
                    id: '11',
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    props: {
                        label: 'Estimated price',
                        name: 'Estimated'
                    }
                },
                {
                    id: '12',
                    type: 'DATE_FIELD',
                    visible: true,
                    props: {
                        label: 'Due date',
                        name: 'DueDate',
                    }
                },
            ]
        },
        {
            id: 1,
            position: {
                row: 1,
                col: 2
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                fullWidth: true
            },
            children: [
                {
                    id: 1,
                    type: 'TEXT_AREA',
                    props: {
                        label: 'Comment',
                        name: 'Comment',
                        size: 'large',
                        style: {
                            height: '100%',
                        }
                    }
                }
            ]
        },
    ]
};

export default PurchaseOrderLineDetailsForm;
